(function($){
    var $fn = $(".comp_wsw");

    if($fn.length){
        var $nav= $fn.find(".wrp_block_nav");
        var $nav_select = $fn.find("[data-pages]");

        $nav.on("click","[data-submenu]",function () {
            var $this = $(this),
                $submenu = $this.next(".elm_submenu");
            $this.toggleClass("mod--active");
            $submenu.stop().slideToggle(500,function () {
                $this.toggleClass("mod--sub-visible");
            })
        });

        $nav_select.on("change",function () {
            window.location = window.location.protocol + "//" + window.location.hostname + $(this).val();
        });

        var $slider = $fn.find("[data-recommendations-slider]");

        if ($slider.children().length > 4) {
            $slider.slick({
                accessibility: false,
                infinite: true,
                speed: 500,
                fade: false,
                focusOnSelect: false,
                slidesToShow: 4,
                cssEase: 'linear',
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: true,
                prevArrow: "<a class='slick-prev slick-arrow icon--chevron-left'></a>",
                nextArrow: "<a class='slick-next slick-arrow icon--chevron-right'></a>",
                pauseOnHover: false,
                dots: false,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    }
})(jQuery);